import { memo, useCallback, useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"

import {
  othersSnippets,
  pinnedSnippets,
  snippetsTabsValue,
} from "rtk-slice"

import { isMobile } from "utils/mediaQuery"

import { Box, Stack } from "@mui/material"

import { useWindowSize } from "@react-hook/window-size"
import {
  useContainerPosition,
  useMasonry,
  usePositioner,
  useResizeObserver,
  useScroller,
} from "masonic"

import SnippetCard from "./snippet-card/SnippetCard"
import SnippetsUIBar from "./ui-bar/SnippetsUIBar"

const MainMasonry = () => {
  const pinnedSnippetsState = useSelector(pinnedSnippets)
  const othersSnippetsState = useSelector(othersSnippets)
  const snippetsTabsValueState = useSelector(snippetsTabsValue)
  const [columnCount, setColumnCount] = useState(0)

  const columnCountCalculator = useCallback(() => {
    let count = 0

    if (
      (!snippetsTabsValueState && pinnedSnippetsState.length <= 1) ||
      (snippetsTabsValueState && othersSnippetsState.length <= 1)
    ) {
      count = 1
    } else {
      count = window.innerWidth > 2000 ? 4 : 2
    }

    setColumnCount(count)
  }, [
    othersSnippetsState.length,
    pinnedSnippetsState.length,
    snippetsTabsValueState,
  ])

  useEffect(() => {
    columnCountCalculator()
  }, [columnCountCalculator])

  const containerRef = useRef(null)
  const [windowWidth, height] = useWindowSize()
  const { offset, width } = useContainerPosition(containerRef, [
    windowWidth,
    height,
  ])
  const { scrollTop, isScrolling } = useScroller(offset)
  const positioner = usePositioner(
    {
      width,
      columnGutter: 16,
      columnCount: isMobile() ? 1 : columnCount,
    },
    [
      !snippetsTabsValueState
        ? pinnedSnippetsState.length
        : othersSnippetsState.length,
    ]
  )
  const resizeObserver = useResizeObserver(positioner)

  return (
    <Box
      sx={{
        position: "relative",
        pb: "1em",
      }}
    >
      {(pinnedSnippetsState.length > 1 && !snippetsTabsValueState) ||
      (snippetsTabsValueState && othersSnippetsState.length > 1) ? (
        <SnippetsUIBar />
      ) : null}

      <Stack mb="7em" px={{ xs: "0.2em", md: "7em" }}>
        {useMasonry({
          itemKey: (data) => data.id,
          positioner,
          scrollTop,
          isScrolling,
          height,
          containerRef,
          items: !snippetsTabsValueState
            ? pinnedSnippetsState
            : othersSnippetsState,
          overscanBy: isMobile() ? 2 : 1.2,
          resizeObserver,
          render: SnippetCard,
        })}
      </Stack>
    </Box>
  )
}

export default memo(MainMasonry)
